import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promotionalchemistreport',
  template: require('./promotionalchemistreport.component.html'),
  styles: []
})
export class PromotionalChemistReportComponent implements OnInit {

  expDetails: any;
  private columnDefs;
  private rowData;
  private rowHeight;
  api: any;
  columnApi: any;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;

  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;



  constructor(

  ) {
    this.columnDefs = [
      { headerName: 'S.No.', field: 'sno', width: 80 },
      { headerName: 'State', field: 'state', width: 200 },
      { headerName: 'Head Qtr', field: 'head_qtr' },
      { headerName: 'SO', field: 'so' },
      { headerName: 'Staff Type', field: 'staff_type', width: 150 },
      { headerName: 'Chemist Name', field: 'chemistname', width: 150 },
      { headerName: 'Type', field: 'type' },
      { headerName: 'Item Code', field: 'item_code' },
      { headerName: 'Item Name', field: 'item_name' },
      { headerName: 'Sample Qty', field: 'sample_qty' },
      { headerName: 'Balance Qty', field: 'balance_qty' },
    ];
    this.defaultColDefine = { resizable: true };
    this.rowData = [
      { sno: '1', state: 'Delhi', head_qtr: "Delhi", so: "Ajeet Barnwal", staff_type: "SO", chemistname: "Prem Medical Store", type: "Chemist", item_code: "1805", item_name: "Carent Digital thermameter", sample_qty: "10", balance_qty: "-10" }
    ];
    this.rowHeight = 50;
  }
  ngOnInit() {
  }
  
  onGridReady = (params) => {
    this.api = params.api;
  }
}
